var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-container",class:{'spinner-container--fullscreen': _vm.fullscreen}},[_c('div',{staticClass:"circle-path"}),_vm._v(" "),_c('h1',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12e753ac","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/used-vue/components/Buy-Online/LoadingSpinner.vue
// module id = xWMy
// module chunks = 16 28 31 34 38 42